import { useEffect, useState } from "react";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { _NationalizationProcessItems } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { AccountEditor } from "../../../../../editor/AccountEditor";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { SelectorUmeasurement } from "../../../../config/Componentes/SelectorUmeasurement";

interface Props {
    IDNationalizationProcessGeneralInfo: number;
}


export const NationalizationProcessItemsByStoreProduct = ({ IDNationalizationProcessGeneralInfo }: Props) => {

    const ByStoreProduct = useDataBean(_NationalizationProcessItems);
    const single = Singleton.getInstance();
    const [Type, setType] = useState<any>(null);
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [IDNationalizationProcessGeneralInfo])

    const getLista = () => {

        ByStoreProduct.instance.getNationalizationProcessItemsRender( IDNationalizationProcessGeneralInfo).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        ByStoreProduct.setBean({
            IDNationalizationProcessGeneralInfo: IDNationalizationProcessGeneralInfo,
            ItemType: ByStoreProduct.bean.ItemType,
            State: 1,
            Since: _single.getCurrenDate(),
            IDEmployee: _single.getAccountID()
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        ByStoreProduct.deleteItemVoid(ByStoreProduct.bean.IDNationalizationProcessItems).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }


    const editaItem = () => {
        //console.log(entailment.bean);
        ByStoreProduct.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDNationalizationProcessItems', visible: true },
        // { title: 'Tipo de  Item / Lote', property: 'ItemType', visible: true },
        // { title: 'Consecutivo de registro', property: 'Item', visible: true },
        { title: 'Lote', property: 'LoteNumber', visible: true },
        { title: 'Cantidad', property: 'Quantity', visible: true },
        { title: 'Parte Numero', property: 'SerialNumberINVM', visible: true },
        { title: 'No. Documento', property: 'NoDocINVM', visible: true },
        { title: 'Unidad de Medida', property: 'MeasurementUnitName', visible: true },
        { title: 'Caso', property: 'CaseNumberINVM', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: true, icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: true, evento: () => { setModal({ ...modal, "name": `Editar ${ByStoreProduct.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: true, evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        // <BasicPage titulo="Items">
            <div className="row">
                {/* <div className="col-md-6">
                    <label>Tipo de  Item / Lote</label>
                    <SelectTHConstantsValue code={602} value={Type} onChange={(e: any) => { setType(e) }}></SelectTHConstantsValue>
                </div> */}
                {/* <div className="col-md-4 mt-4 p-2">
                    <BasicButton icon="ri-send-plane-fill" clase="primary" eventClick={getLista}>Buscar por Item / Lote</BasicButton>
                </div> */}
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={ByStoreProduct.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            {/* <div className="col-md-12">
                                <label>Tipo de  Item / Lote</label>
                                <SelectTHConstantsValue code={602} value={ByStoreProduct.bean.ItemType} onChange={(e: any) => { ByStoreProduct.setBean({ ...ByStoreProduct.bean, "ItemType": e }) }}></SelectTHConstantsValue>
                            </div> */}
                            {/* <div className="col-md-6">

                                <label>No.Consecutivo de registro item</label>
                                <input type="text" name="Item" className="form-control" value={ByStoreProduct.bean.Item} onChange={ByStoreProduct.handleChange} />

                            </div> */}
                            <div className="col-md-6">
                                <SelectorUmeasurement titulo='Unidad de Medida' idSelector={ByStoreProduct.bean.MeasureUnitINVM} onChange={(e) => { ByStoreProduct.setBean({ ...ByStoreProduct.bean, "MeasureUnitINVM": e }) }} />
                            </div>
                            <div className="col-md-6">

                                <label>No. Documento</label>
                                <input type="text" name="NoDocINVM" className="form-control" value={ByStoreProduct.bean.NoDocINVM} onChange={ByStoreProduct.handleChange} />

                            </div>
                            <div className="col-md-6">

                                <label>Parte Número</label>
                                <input type="text" name="SerialNumberINVM" className="form-control" value={ByStoreProduct.bean.SerialNumberINVM} onChange={ByStoreProduct.handleChange} />

                            </div>
                            <div className="col-md-6">

                                <label>Caso</label>
                                <input type="text" name="CaseNumberINVM" className="form-control" value={ByStoreProduct.bean.CaseNumberINVM} onChange={ByStoreProduct.handleChange} />

                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {ByStoreProduct.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        // </BasicPage>
    )
}